import Pristine from "pristinejs/dist/pristine";
$.fn.formValidate = function() {
    $(this).each((k, form) => {
        const $form = $(form);
        form.validator = new Pristine(form, {
            classTo: 'field',
            errorClass: 'is-danger',
            successClass: 'is-valid',
            errorTextParent: 'field',
            errorTextTag: 'p',
            errorTextClass: 'help'
        }, false);

        $form
            .on('change', 'input, textarea, select', function () {
                form.validator.validate(this);
            })
            .submit((e) => {
                e.preventDefault();
                if (!form.validator.validate()) {
                    let $f = $form.find('.field.is-danger').first()[0];
                    if ($f) {
                        try {
                            $f.scrollIntoView({behavior: 'smooth', block: 'center'});
                        } catch (e) {}
                    }
                    return false;
                }
                var isFormData = $form.attr('enctype') === 'multipart/form-data';
                var data = isFormData ? new FormData($form[0]) : $form.serializeArray();
                preloader(1);
                $form.find('.is-not-autocompleted').each(function() {
                    var $el = $(this);
                    if ($el.data('form-name') && !$el.is(':disabled')) {
                        if (isFormData) {
                            data.append($el.data('form-name'), $el.val());
                        } else {
                            data.push({name: $el.data('form-name'), value: $el.val() });
                        }
                    }
                })

                if (!isFormData) {
                    $form.data('payload', data);
                    data = $.param(data);
                }

                $.ajax({
                    url: $form.attr('action'),
                    data: data,
                    processData: !isFormData,
                    contentType: isFormData ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
                    type: 'POST',
                    success: (response) => {
                        preloader(0);
                        $form.data('lastResponse', response);
                        if (!response.error) {
                            form.validator.reset();
                            $form.trigger('success', response);
                        } else if (response.error) {
                            if (response.error.message) {
                                if (typeof response.error.message === 'string') {
                                    alert(response.error.message);
                                } else {
                                    let errors = [];
                                    $.each(response.error.message, (field, error) => {
                                        let $input, $modal;
                                        let normalizedField = field.split('.').map(function(v, k) {
                                            if (k === 0) {
                                                return v;
                                            }
                                            return '[' + v + ']'
                                        }).join('');

                                        $input = $form.find(`[name="${normalizedField}"], [data-form-name="${normalizedField}"]`);
                                        $modal = $input.closest('.modal');
                                        if ($input.length > 0) {
                                            $input.each(function() {
                                                if ($(this).is(':visible')) {
                                                    form.validator.addError(this, error);
                                                }
                                            });
                                        } else {
                                            errors.push(`${field}: ${error}`);
                                        }
                                        if ($modal.length && !$modal.is('.in')) {
                                            $modal.modal('show');
                                        }
                                    });

                                    if (errors.length > 0) {
                                        alert(errors.join('\n'));
                                    }

                                    let $f = $form.find('.field.is-danger').first()[0];
                                    if ($f) {
                                        try {
                                            $f.scrollIntoView({behavior: 'smooth', block: 'center'});
                                        } catch (e) {}
                                    }
                                }
                                $form.trigger('error', response.error.message);
                            } else {
                                $form.trigger('error', response.error);
                            }
                        }
                    }
                });
                return false;
            })
    });
    return this;
}